module.exports = __webpack_public_path__ + "a9c80d5c81baed19bb89b1516785972c.fbx";